/**
 * Tampilan mana yang dipasang: yang lama, atau rancang ulang.
 *
 * Keduanya ada dalam SATU build dan dipindah PER APLIKASI (ADR-094 no. 10). Memindahkan
 * sebuah aplikasi berarti mengubah SATU baris di `SUDAH_PINDAH`; build sebelumnya tetap
 * ada sebagai jalan mundur (`docs/OPERASI.md`).
 *
 * Kedua aplikasi sudah pindah (ADR-122, 22 Okt 2026): rancang ulang jadi bawaan untuk
 * semua orang. Tampilan lama masih ada sebagai jalan mundur, HANYA DI DEV:
 *
 *     https://…/hari-ini?ui=lama     buka tampilan lama, dan ingat pilihannya
 *     https://…/hari-ini?ui=baru     buka rancang ulang, dan ingat pilihannya
 *     https://…/hari-ini?ui=bawaan   lupakan pilihannya
 *
 * Pilihan itu disimpan di peramban, jadi operator bisa membandingkan di VPS dev tanpa
 * mengubah apa yang dilihat orang lain. Di produksi parameternya diabaikan: yang tampil
 * selalu bawaannya.
 */
import { DI_DEV } from '../shared/lib/lingkungan'
import { aplikasiPeran } from '../kerangka/rute'

const KUNCI = 'smova.ui'
const SAH = ['baru', 'lama']

// Aplikasi yang tampilan barunya sudah jadi bawaan. Diubah di commit yang memindahkannya.
export const SUDAH_PINDAH = { tenant: true, smova: true }

function tersimpan() {
  if (!DI_DEV) return null
  try {
    const v = localStorage.getItem(KUNCI)
    return SAH.includes(v) ? v : null
  } catch {
    return null
  }
}

function simpan(v) {
  try {
    if (SAH.includes(v)) localStorage.setItem(KUNCI, v)
    else localStorage.removeItem(KUNCI)
  } catch {
    // Penyimpanan diblokir: pilihannya tidak bisa diingat, dan tampilan bawaan yang dipakai.
  }
}

/** Pilihan yang sedang berlaku di peramban ini: 'baru', 'lama', atau null (bawaan). */
export function pilihanTampilan() {
  return tersimpan()
}

/**
 * Baca `?ui=` SEKALI saat aplikasi dimuat, simpan, lalu buang dari alamat.
 *
 * Dibuang supaya tautan yang disalin dari bilah alamat tidak membawa pilihan itu ke
 * peramban orang lain, dan supaya router tidak pernah melihatnya. Mengembalikan true
 * kalau alamatnya diubah.
 */
export function bacaParamTampilan(lokasi = window.location, riwayat = window.history) {
  const p = new URLSearchParams(lokasi.search)
  if (!p.has('ui')) return false
  if (DI_DEV) simpan(p.get('ui'))
  p.delete('ui')
  const sisa = p.toString()
  riwayat.replaceState(riwayat.state, '', lokasi.pathname + (sisa ? `?${sisa}` : '') + lokasi.hash)
  return true
}

/** Muat ulang halaman. Fungsi tersendiri supaya uji bisa menggantinya. */
export function muatUlangHalaman() {
  window.location.reload()
}

/**
 * Apakah orang berperan `peran` melihat rancang ulang?
 *
 * Tanpa peran (belum masuk), layar masuk mengikuti APLIKASI TENANT: penggunanya paling
 * banyak, dan merekalah yang akan melihat dua gaya berturut-turut kalau layar masuknya
 * tertinggal. Operator Smova yang masuk lewat layar baru sebelum aplikasinya pindah
 * dibawa `Akar.jsx` ke tampilan lama.
 */
export function pakaiTampilanBaru(peran) {
  const p = tersimpan()
  if (p) return p === 'baru'
  if (!peran) return SUDAH_PINDAH.tenant
  // Peran yang tidak dikenal tidak punya aplikasi; ia jatuh ke tampilan lama, yang
  // menampilkan layar "sesi tidak bisa dipercaya".
  return SUDAH_PINDAH[aplikasiPeran(peran)] ?? false
}
